<template>
  <div class="maintenance-container">
    <div class="maintenance-card">
      <img src="/favicon-32x32.png" alt="Kevi" class="maintenance-logo" />
      <h1>Estamos em manutenção</h1>
      <p>
        O sistema está temporariamente indisponível enquanto realizamos melhorias.
        Por favor, tente novamente em breve.
      </p>
      <div class="maintenance-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#7b8794" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Maintenance",
};
</script>

<style scoped>
.maintenance-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f0f4f8;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.maintenance-card {
  text-align: center;
  background: #fff;
  border-radius: 12px;
  padding: 48px 40px;
  max-width: 480px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.maintenance-logo {
  width: 48px;
  height: 48px;
  margin-bottom: 24px;
}

.maintenance-card h1 {
  font-size: 24px;
  color: #1a2b3c;
  margin: 0 0 12px;
  font-weight: 600;
}

.maintenance-card p {
  font-size: 16px;
  color: #5a6872;
  line-height: 1.6;
  margin: 0 0 32px;
}

.maintenance-icon {
  opacity: 0.5;
}
</style>
